import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BASE_URL } from "./Config";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const { email, number } = location.state || {};

  // type = "email" or "phone"
  const [type, setType] = useState(email ? "email" : number ? "phone" : "");

  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });

  const [status, setStatus] = useState("");
  const [statustype, setStatustype] = useState("");
  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.password || !formData.confirmPassword) {
      setStatus("❌ Both password fields are required");
      setStatustype("err");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setStatus("❌ Passwords do not match");
      setStatustype("err");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${BASE_URL}/reset_password.php?type=email&t=${Date.now()}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: type,
            email,
            number,
            newPassword: formData.password,
            currentPassword: formData.confirmPassword,
          }),
        }
      );

      const result = await response.json();

      if (result.success) {
        setStatus("✅ Password updated successfully!");
        setStatustype("success");

        setTimeout(() => {
          navigate("/login");
        }, 1500);
      } else {
        setStatus("❌ " + result.message);
        setStatustype("err");
      }
    } catch (err) {
      console.error(err);
      setStatus("❌ Something went wrong!");
      setStatustype("err");
    }

    setLoading(false);
    setTimeout(() => {
      setStatus("");
      setStatustype("");
    }, 4000);
  };

  return (
    <div className="container pb-5">
      <div className="row">
        <div className="col-12 pt-5">
          <div className="logo">
            <Link to="/">
              <img
                src={`${BASE_URL}/images/fastrade_logo.jpg`}
                style={{ width: "220px" }}
                alt="Fast Trade "
              />
            </Link>
          </div>
        </div>
        <div className="col-12 pt-4 login_alert">
          <div className="status-massage text-center">
            <p className={statustype}> {status}</p>
          </div>
          <div className="login-form">
            <form onSubmit={handleSubmit}>
              <div className="form-page">
                <h2>Enter New Password</h2>

                <div className="inputs pt-3">
                  {/* Password Field with Eye */}
                  <div style={{ position: "relative" }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="New Password"
                      className="number_input"
                      value={formData.password}
                      onChange={(e) =>
                        setFormData({ ...formData, password: e.target.value })
                      }
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "15px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#555",
                      }}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>

                  {/* Confirm Password Field with Eye */}
                  <div style={{ position: "relative", marginTop: "15px" }}>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Confirm Password"
                      className="number_input"
                      value={formData.confirmPassword}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          confirmPassword: e.target.value,
                        })
                      }
                    />
                    <span
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      style={{
                        position: "absolute",
                        right: "15px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#555",
                      }}
                    >
                      {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </div>

                <div className="submit-btn pt-3">
                  <input
                    type="submit"
                    value={loading ? "Resetting..." : "Reset Password"}
                    className="btn btn-primary"
                    style={{
                      width: "100%",
                      backgroundColor: "#128DE5",
                      padding: "10px",
                      marginBottom: "15px",
                      fontWeight: "600",
                    }}
                    disabled={loading}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
